module.exports = __webpack_public_path__ + "static/media/the-simple-shellfish-boat.0f65e5d5.jpg";